module.exports = __webpack_public_path__ + "media/images/marker_blue-f27bda531159a621b61a84b8cfb8d009.png";